export default __webpack_public_path__ + "static/brand-protection-e08e2a6197e0134dea82a5bb211abd2b.png";